import QRCode from 'qrcode';
import { useEffect, useRef } from 'react';

export const KioskQrCanvas = ({
  value,
  size = 320,
  label,
}: {
  value: string;
  size?: number;
  label: string;
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !value) return;

    void QRCode.toCanvas(canvas, value, {
      width: size,
      margin: 2,
      errorCorrectionLevel: 'H',
      color: { dark: '#0f172a', light: '#ffffff' },
    });
  }, [size, value]);

  return (
    <canvas
      ref={canvasRef}
      role="img"
      aria-label={label}
      className="checkin-qr-canvas"
      width={size}
      height={size}
    />
  );
};
